import {LiveStreamNativePlayer} from './video-live-stream-player-native';

export class VideoOnDemandNativePlayer extends LiveStreamNativePlayer {
    load() {
        super.play();
        super.pause();
        this.rewind();
    }

    onWatchTimeLimitReached() {

    }

    private rewind() {
        this.videoReference.currentTime = 0;
    }
}
